"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.when = exports.match = void 0;
function match() {
  var cases = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    cases[_i] = arguments[_i];
  }
  return function (x) {
    var e_1, _a;
    try {
      for (var cases_1 = __values(cases), cases_1_1 = cases_1.next(); !cases_1_1.done; cases_1_1 = cases_1.next()) {
        var _b = __read(cases_1_1.value, 2),
          T = _b[0],
          f = _b[1];
        if (T.guard(x)) return f(x);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (cases_1_1 && !cases_1_1.done && (_a = cases_1.return)) _a.call(cases_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    throw new Error('No alternatives were matched');
  };
}
exports.match = match;
function when(runtype, transformer) {
  return [runtype, transformer];
}
exports.when = when;